import Box from "@mui/material/Box";
import BreadCrumb from "app/components/BreadCrumb";
import { ScrollableView } from "app/components/ScrollableView";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";

import ActionBar from "./components/ActionBar";
import AddSuperModelModal from "./components/AddSuperModelModal";
import SuperModelTable from "./components/SuperModelTable";
import {
  selectSuperModelMeta,
  selectSuperModelsList,
  selectSuperModelsLoading,
} from "./redux/selector";
import superModelSaga from "./redux/saga";
import { superModelActions, reducer, sliceKey } from "./redux/slice";
import { useStyles } from "./styles";

const SuperModel = () => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();

  useInjectReducer({
    key: sliceKey,
    reducer,
  });

  useInjectSaga({
    key: sliceKey,
    saga: superModelSaga,
  });

  const rows = useSelector(selectSuperModelsList);
  const loading = useSelector(selectSuperModelsLoading);
  const meta = useSelector(selectSuperModelMeta);

  useEffect(() => {
    dispatch(superModelActions.getSuperModelsList());
  }, [dispatch]);

  const hasMoreItems = meta.currentPage < meta.totalPages;

  const getNextPage = () => {
    if (!loading && hasMoreItems) {
      dispatch(superModelActions.getNextPageItems());
    }
  };

  return (
    <Box className={styles.container}>
      <Box className={styles.scrollContent} dir={i18n.dir()}>
        <Box className={styles.pageContent}>
          <BreadCrumb title={t("SIDEBAR.MASTER_MODEL")} iconPosition="end" />
          <ActionBar
            onAddClick={() => dispatch(superModelActions.openAddModal())}
          />
          <Box className={styles.tableContainer}>
            <ScrollableView
              borderless
              height="calc(100vh - 200px)"
              loadMore={getNextPage}
              hasMoreItems={hasMoreItems}
            >
              <SuperModelTable rows={rows} loading={loading} />
            </ScrollableView>
          </Box>
        </Box>
      </Box>
      <AddSuperModelModal />
    </Box>
  );
};

export default SuperModel;
